import { HasPermission } from '@shared/components/permission/has-permission';
import { PropsWithChildren, FC } from 'react';

import { CreateCostCenterDrawer } from '../../cost-center-form-drawer/create-cost-center-drawer/create-cost-center-drawer';

export const CostCentersHeader: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex justify-between items-center mb-4">
      {children}

      <HasPermission permissionFeature="COST_CENTER_CREATE_COST_CENTER" permissionType="WRITE">
        <CreateCostCenterDrawer />
      </HasPermission>
    </div>
  );
};
